// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type FileSvgrepoComsvgIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function FileSvgrepoComsvgIcon(props: FileSvgrepoComsvgIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      x={"0"}
      y={"0"}
      viewBox={"0 0 511 511"}
      xmlSpace={"preserve"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",

        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        d={
          "M454.962 110.751c-.018-.185-.05-.365-.081-.545-.011-.06-.016-.122-.028-.182a7.298 7.298 0 00-.159-.632c-.007-.025-.012-.052-.02-.077a7.357 7.357 0 00-.224-.625l-.023-.064a7.61 7.61 0 00-.269-.57c-.016-.031-.029-.063-.045-.094a7.977 7.977 0 00-.301-.504c-.027-.042-.05-.086-.077-.127a7.546 7.546 0 00-.33-.446c-.037-.048-.07-.098-.109-.145a7.864 7.864 0 00-.45-.498l-.042-.046-104-104c-.018-.018-.038-.033-.057-.051a7.503 7.503 0 00-.486-.44c-.055-.045-.113-.083-.169-.126-.138-.107-.275-.214-.42-.311-.051-.034-.105-.062-.156-.095a7.352 7.352 0 00-.475-.284c-.036-.019-.074-.035-.111-.053a7.79 7.79 0 00-.554-.262c-.024-.01-.049-.017-.074-.027a7.637 7.637 0 00-.616-.221l-.081-.021a7.686 7.686 0 00-.628-.158c-.063-.013-.128-.018-.192-.029a7.203 7.203 0 00-.536-.08A7.468 7.468 0 00343.5 0h-248C73.72 0 56 17.72 56 39.5v432c0 21.78 17.72 39.5 39.5 39.5h320c21.78 0 39.5-17.72 39.5-39.5v-360c0-.251-.013-.501-.038-.749zM351 25.606L429.394 104H375.5c-13.509 0-24.5-10.99-24.5-24.5V25.606zM415.5 496h-320C81.991 496 71 485.01 71 471.5v-432C71 25.99 81.991 15 95.5 15H336v64.5c0 21.78 17.72 39.5 39.5 39.5H440v352.5c0 13.51-10.991 24.5-24.5 24.5z"
        }
      ></path>
    </svg>
  );
}

export default FileSvgrepoComsvgIcon;
/* prettier-ignore-end */
